import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ApprovedRouteProps {
  children: React.ReactNode;
}

const ApprovedRoute: React.FC<ApprovedRouteProps> = ({ children }) => {
  const { currentUser, isApproved, isAdmin } = useAuth();

  if (!currentUser) {
    // Redirect to login page if user is not authenticated
    return <Navigate to="/login" replace />;
  }

  if (!isApproved && !isAdmin) {
    // Redirect to dashboard if user is not approved and not admin
    return <Navigate to="/portal/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ApprovedRoute; 